import { gql } from '@apollo/client';

export const GET_RELATED_INCIDENTS = gql`
  query GET_RELATED_INCIDENTS($incidentId: ID!, $originatorId: ID!){
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      id
      uuid
      relatedIncidents {
        id
        incidentNumber
        incidentDetail {
          id
        }
        classification {
          id
          name
        }
        sealed
        locked
        callTime
        officerIncidentSpecifics {
          primaryOfficer
          id
          officer {
            id
            deptAttribute {
              id
              ori {
                id
                oriName
                abbreviation
              }
              badge
            }
          }
        }
      }
    }    
  }
`